export const appendQueryParams = (url, queryParams) => {
    if (url.includes('?')) {
        return url + '&' + queryParams;
    } else {
        return url + '?' + queryParams;
    }
}

